{
  "en": {
    "validation": {
      "emailTaken": "Email address is already taken",
      "import": {
        "inclusion": "Error in line {rowNumber} column {columnNumber}: {headerName} is not included in the list",
        "inclusion_values": "with allowed values: {values}",
        "invalid": "Error in line {rowNumber} column {columnNumber}: {headerName} is not valid",
        "required": "Error in line {rowNumber} column {columnNumber}: a value for {headerName} is required",
        "unique": "Error in line {rowNumber}: {headerName} is not unique, there is another row with this value"
      },
      "nameAlreadyTaken": "Name is already taken",
      "needCompany": "Company is required",
      "needName": "Name is required"
    }
  }
}
